module.exports = __webpack_public_path__ + "img/jaboatao_xmas_background_hero.6e5e93b2.png";